import { useSession as useNextAuthSession } from "next-auth/react"
import type { NovaSession } from "@/types"

type UpdateSession = (data?: any) => Promise<NovaSession | null>

export const useSession = () => useNextAuthSession() as { data: NovaSession | null; update: UpdateSession }
